import { createContext, useState, useContext } from "react";

const TransactionContext = createContext();

export const TransactionProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState({
    phoneNumber: 0,
    cardSerNo: "0",
    deviceId: "0",
    superMoneyAccountId: "",
    last4Digits: 0
  });

  return (
    <TransactionContext.Provider
      value={{
        userDetails,
        setUserDetails
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
};

export const useTransaction = () => useContext(TransactionContext);
